/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Workspace API
 * Workspace builder APIs for FormOps
 * OpenAPI spec version: 1.0
 */

/**
 * Scalar value type of the variable.
 */
export type CreateDataLibraryVariableRequestValueType = typeof CreateDataLibraryVariableRequestValueType[keyof typeof CreateDataLibraryVariableRequestValueType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateDataLibraryVariableRequestValueType = {
  text: 'text',
  number: 'number',
  boolean: 'boolean',
  date: 'date',
} as const;
